import { wsService } from "./wsService";
import sections from "@/constants/sections";

const section = sections.SECTION_RESOURCES;

function filter(param = { enable: true }) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function list_types() { 
  return wsService.make_post_request(section + "/list-types");
}


export const resourceService = {
  section,
  filter,
  remove,
  create,
  update,
  list_types,
};
